import { IllustrationBlob, IllustrationBlobSize, IllustrationBlobType } from '../../illustration-blob'
import { Blob05 } from '../../shape'
import { ModalSheet, ModalSheetContent, ModalSheetFooter, ModalSheetHeader } from '../modal-sheet'
import type { ModalDialogProps, ModalDialogVariantType } from './types'
import { ModalDialogVariant } from './types'

const mapperIllustrationBlobTypes: Map<ModalDialogVariantType, IllustrationBlobType> = new Map([
  [ModalDialogVariant.confirmation, IllustrationBlobType.positive],
  [ModalDialogVariant.destructive, IllustrationBlobType.critical],
])

const ModalDialog = ({
  body,
  cancelButton,
  confirmButton,
  imgSrc,
  imgAlt,
  subtitle,
  variant,
  title,
  children,
  ...props
}: ModalDialogProps) => {
  const ConfirmButton = confirmButton
  const CancelButton = cancelButton
  return (
    <ModalSheet role="alertdialog" {...props}>
      <ModalSheetHeader title={title} subtitle={subtitle}>
        {imgSrc && imgAlt && (
          <IllustrationBlob
            shape={Blob05}
            size={IllustrationBlobSize.large}
            src={imgSrc}
            alt={imgAlt}
            type={mapperIllustrationBlobTypes.get(variant)}
          />
        )}
      </ModalSheetHeader>
      <ModalSheetContent>
        {body && <span className="pintxo-typography-body1">{body}</span>}
        {children}
      </ModalSheetContent>
      <ModalSheetFooter>
        {ConfirmButton && ConfirmButton}
        {CancelButton && CancelButton}
      </ModalSheetFooter>
    </ModalSheet>
  )
}
export default ModalDialog
